import errorManager from '@/rollbar.js';

const setObserver = (selectors) => {
  const { waitEvent } = selectors;
  const eventToLoadWait = `loadingReady::${waitEvent}`;
  waiting(selectors, eventToLoadWait);
};

const waiting = (selectors, eventToLoadWait) => {
  const { wrapper, area, waitEvent, DOMFromNestedVue, dataToSend } = selectors;
  const numberoOfWaits = $(`${wrapper}`).find(`${area}`).length;
  if (!numberoOfWaits) {
    return false;
  }
  Loader.show();
  eventBus.$on(eventToLoadWait, () => Loader.hide());
  if (!DOMFromNestedVue) {
    waitingFromEvent(numberoOfWaits, waitEvent, eventToLoadWait);
  } else {
    waitingFromMutation(selectors, eventToLoadWait, dataToSend);
  }
};

const waitingFromEvent = (numberoOfWaits, waitEvent, eventToLoadWait) => {
  let areaLoaded = [];
  eventBus.$on(waitEvent, (data) => {
    areaLoaded = waitingLoading(data, numberoOfWaits, areaLoaded, eventToLoadWait);
  });
};

const waitingFromMutation = (selectors, eventToLoadWait, dataToSend) => {
  const { wrapper, area } = selectors;
  let changeInPending = true;
  const observer = new MutationObserver(() => {
    changeInPending = true;
  });
  observer.observe(document.querySelector(`${wrapper} ${area}`), { attributes: true, childList: true, characterData: true, subtree: true });
  let pendingWaiting = () => {
    if (changeInPending) {
      changeInPending = false;
      setTimeout(pendingWaiting, 500);
    } else {
      observer.takeRecords();
      observer.disconnect();
      console.log('NO MORE MUTATIONS!');
      eventBus.$emit(eventToLoadWait, dataToSend);
    }
  };
  pendingWaiting();
};

const waitingLoading = (data, numberoOfWaits, areaLoaded, eventToLoadWait) => {
  const { id } = data;
  const findArea = areaLoaded.findIndex((loaded) => loaded.id == id);
  if (findArea === -1) {
    areaLoaded = [...areaLoaded, data];
  }
  if (numberoOfWaits == areaLoaded.length) {
    eventBus.$emit(eventToLoadWait, { areaLoaded });
  }
  return areaLoaded;
};

const init = (selectors) => {
  try {
    setObserver(selectors);
  } catch (e) {
    errorManager(e);
  }
};

window.loading = {
  init,
};
